import { loaderIndicatorType } from 'src/sdk-components/LoaderIndicator';
import { MpSdk } from 'src/types';
import Scene from '../../scene';

class SceneLoader extends Scene {
  constructor(
    mpSDK: MpSdk,
    private url: string | null,
  ) {
    super(mpSDK);
  }

  async create(): Promise<any> {
    const modelNode = await this.scene.createNode();
    const component = modelNode.addComponent(loaderIndicatorType, {
      url: this.url,
    });
    modelNode.start();

    return [modelNode, component];
  }
}

export default SceneLoader;
